module.exports = __webpack_public_path__ + "img/08.06df527e.png";